import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { WorkspaceService } from '../../../../app/shared/services/workspace.service';
import { GlobalServices } from '../../../../app/shared/services/global.service';
import { User } from '../../shared/models/user.model';
import { RegisterType } from '../../../../app/shared/models/enums.model';
import { EtenderService } from '../../../../app/shared/services/etender.service';
import { ETenderAdminTypes } from '../../../../app/shared/models/e-tender.model';
import { MessagingService } from '../../../../app/shared/services/messaging.service';

@Component({
  selector: 'app-workspace',
  templateUrl: './workspace.component.html',
  styleUrls: ['./workspace.component.css']
})

export class WorkspaceComponent implements OnInit {
  IsAdmin: boolean;
  NavigationRequests:boolean = false;
  IsETenderAdmin = false;
  IsRegistrationAdmin = false;
  IsEbookingAdmin = false;
  IsSupplierAdmin = false;
  IsLongHaulAdmin = false;
  IsLongHaulManageandReportsOnly = false;
  IsLongHaulReportAdmin = false;
  IsSmallUnitsAdmin = false;
  IsChangeCrewAdmin = false;
  IsCircularAdmin = false;
  IsReleaseAdmin = false;
  IsCircularReportAdminOnly = false;
  IsCircularReportAdmin = false;
  IsSmallUnitsAdminOnly = false;
  registerationType: number;
  RegisterType = RegisterType;
  myNotifications: any;
  userGroups: number[] = [];
  creator = false;
  user = new User();
  isShipyardAdmin: boolean = false;
  IsReleaseReportAdmin: boolean = false;
  constructor(private workspaceService: WorkspaceService, private authenSrv: AuthenticationService,
    private etenderSrv: EtenderService, private global: GlobalServices,
    private messagingService: MessagingService) {
    this.user = this.authenSrv.currentUserValue;
    //this.user = this.global.user;
    this.IsAdmin = this.user.IsAdmin;
  }

  ngOnInit() {
    this.global.IsLoaderEnabled = true;
    if (!this.IsAdmin)
      this.registerationType = this.user.RegisterTypeId;
    this.getUserGroups();
    this.getUserNotificationsCounts();
    setInterval(() => { this.getUserNotificationsCounts(); }, 30000);
    // reset MyTaksPageNumber that set when paginate in my tasks component
    //localStorage.setItem('MyTasksSelectedPageNumber', '1');
    this.global.myTasksSortsndPagingCriteria = [];
  }
  getUserGroups() {
    this.etenderSrv.GetUserGroups(this.user.Email).subscribe(
      data => {
        this.userGroups = data.Data;
        if (this.userGroups != null) {
          if (this.userGroups.filter(a => a == ETenderAdminTypes.SCAServices_ETenderCreators ||
            a == ETenderAdminTypes.SCAServices_ETenderPurchasingCategoryAdmins).length > 0) {
            this.creator = true;
          }
          if (this.userGroups.filter(ug => ug == ETenderAdminTypes.SCAServices_ETender_MessagingAdmins).length > 0) {
            this.IsETenderAdmin = true;
          }


          if (this.user.RegisterTypeId == RegisterType.Agent ||this.user.RegisterTypeId == RegisterType.PortalUser ) {
            this.NavigationRequests = true;
          }
          else
          {
            this.NavigationRequests = false;
          }


          if (this.userGroups.filter(a => a == ETenderAdminTypes.SCAServices_FiberglassAdmin ||
            a == ETenderAdminTypes.SCAServices_FloatingAdmin ||
            a == ETenderAdminTypes.SCAServices_QualityAdmin ||
            a == ETenderAdminTypes.SCAServices_RepairAdmin ||
            a == ETenderAdminTypes.SCAServices_SalvageAdmin ||
            a == ETenderAdminTypes.SCAServices_ShipyardAdmin).length > 0) {
            this.isShipyardAdmin = true;
          }
          if (this.userGroups.filter(ug => ug == ETenderAdminTypes.SCAServices_RegistrationAdmin).length > 0) {
            this.IsRegistrationAdmin = true;
          }
          if (this.userGroups.filter(ug => ug == ETenderAdminTypes.SCAServices_RegistrationAdmin ||
            ug == ETenderAdminTypes.SCAServices_MeasurementDepartmentManager ||
            ug == ETenderAdminTypes.SCAServices_MeasurementDepartmentManager_Suez ||
            ug == ETenderAdminTypes.SCAServices_MarineNavigationOfficer ||
            ug == ETenderAdminTypes.SCAServices_MarineNavigationOfficer_Suez ||
            ug == ETenderAdminTypes.SCAServices_MeasurementOfficer ||
            ug == ETenderAdminTypes.SCAServices_MeasurementOfficer_Suez ||
            ug == ETenderAdminTypes.SCAServices_TreasuryOfficer ||
            ug == ETenderAdminTypes.SCAServices_MeasurementsOfficerReviewer ||
            ug == ETenderAdminTypes.SCAServices_EBooking_MessagingAdmins ||
            ug == ETenderAdminTypes.SCAServices_AgentReg_MessagingAdmins ||
            ug == ETenderAdminTypes.SCAServices_FeesEstimation_MessagingAdmins ||
            ug == ETenderAdminTypes.SCAServices_UpdateAgentProfile_MessagingAdmins ||
            ug == ETenderAdminTypes.SCAServices_TransitRequest_MessagingAdmins ||
            ug == ETenderAdminTypes.SCAServices_NavigationOfficer ||
            ug == ETenderAdminTypes.SCAServices_SmallUnits_FinancePS || 
            ug == ETenderAdminTypes.SCAServices_SmallUnits_FinancePT 
          ).length > 0) {
            this.IsEbookingAdmin = true;
          }
          if (this.userGroups.filter(a => a == ETenderAdminTypes.SCAServices_ETenderTechnicalCategoryAdmins ||
            a == ETenderAdminTypes.SCAServices_ETenderPurchasingCategoryAdmins ||
            a == ETenderAdminTypes.SCAServices_ETenderPurchasingDivisionManager ||
            a == ETenderAdminTypes.SCAServices_ETenderTechnicalDivisionManagers).length > 0) {
            this.IsSupplierAdmin = true;
          }

          if (this.userGroups.filter(ug => ug == ETenderAdminTypes.SCAServices_CrewChange_Approval ||
            ug == ETenderAdminTypes.SCAServices_CrewChange_Reviewer
           ).length > 0) {
            this.IsChangeCrewAdmin = true;
          }
          //this.IsChangeCrewAdmin = true;


          if (this.userGroups.filter(ug => ug == ETenderAdminTypes.SCAServices_MeasurementCommittee ||
            ug == ETenderAdminTypes.SCAServices_EconomicCommittee ||
            ug == ETenderAdminTypes.SCAServices_LongHaulFormulatedDecision).length > 0) {
            this.IsLongHaulAdmin = true;
          }
          if (this.userGroups.filter(ug => ug == ETenderAdminTypes.SCAServices_LHManagementandReportsOnly).length > 0) {

            this.IsLongHaulReportAdmin = true;
            this.IsLongHaulManageandReportsOnly = true;
          }
          if (this.userGroups.filter(ug => ug == ETenderAdminTypes.SCAServices_MeasurementSuez ||
            ug == ETenderAdminTypes.SCAServices_MeasurementPortSaid).length > 0) {
            this.IsLongHaulReportAdmin = true;
          }

          if (this.userGroups.filter(ug => ug == ETenderAdminTypes.SCAServices_ReleaseReports).length > 0) {
            this.IsReleaseReportAdmin = true;
          }
          if (this.userGroups.filter(ug => ug == ETenderAdminTypes.SCAServices_SmallUnits_smallunitsPS ||
            ug == ETenderAdminTypes.SCAServices_RefundDeputyManager ||
            ug == ETenderAdminTypes.SCAServices_RefundEunitGroup ||
            ug == ETenderAdminTypes.SCAServices_RefundFirstReviewer ||
            ug == ETenderAdminTypes.SCAServices_RefundManager ||
            ug == ETenderAdminTypes.SCAServices_RefundMeasurementManager ||
            ug == ETenderAdminTypes.SCAServices_RefundMeasurementPrint ||
            ug == ETenderAdminTypes.SCAServices_RefundSecondReviewer ||
            ug == ETenderAdminTypes.SCAServices_RestudyEconomicApprove ||
            ug == ETenderAdminTypes.SCAServices_RestudyManager ||
            ug == ETenderAdminTypes.SCAServices_RestudyReviewer ||
            ug == ETenderAdminTypes.SCAServices_ReleaseReports  ||
            ug == ETenderAdminTypes.SCAServices_RestudyEconomic
          ).length > 0) {
            this.IsReleaseAdmin = true;
          }

          if (this.userGroups.filter(ug => ug == ETenderAdminTypes.SCAServices_SmallUnits_smallunitsPS ||
            ug == ETenderAdminTypes.SCAServices_SmallUnits_smallunitsPT ||
            ug == ETenderAdminTypes.SCAServices_SmallUnits_smallunitsIS ||
            ug == ETenderAdminTypes.SCAServices_SmallUnits_FinancePS ||
            ug == ETenderAdminTypes.SCAServices_SmallUnits_FinancePT ||
            ug == ETenderAdminTypes.SCAServices_SmallUnits_ISMMarine ||
            ug == ETenderAdminTypes.SCAServices_MarineNavigationOfficer ||
            ug == ETenderAdminTypes.SCAServices_MarineNavigationOfficer_Suez ||
            ug == ETenderAdminTypes.SCAServices_MeasurementOfficer ||
            ug == ETenderAdminTypes.SCAServices_MeasurementOfficer_Suez ||
            ug == ETenderAdminTypes.SCAServices_TreasuryOfficer ||
            ug == ETenderAdminTypes.SCAServices_SmallUnits_MessagingAdmins
          ).length > 0) {
            this.IsSmallUnitsAdmin = true;
          }
          if (this.userGroups.filter(
            ug =>
            ug == ETenderAdminTypes.SCAServices_circulars_measurement_first ||
            ug == ETenderAdminTypes.SCAServices_circulars_measurement_second ||
            ug == ETenderAdminTypes.SCAServices_circulars_measurement_third

          ).length > 0) {
            this.IsCircularAdmin = true;
          }
          if (this.userGroups.filter(
            ug => ug == ETenderAdminTypes.SCAServices_circulars_Reports
          ).length > 0 && this.userGroups.length == 1) {
            this.IsCircularReportAdminOnly = true;
          }
          if (this.userGroups.filter(
            ug => ug == ETenderAdminTypes.SCAServices_circulars_Reports
          ).length > 0 ) {
            this.IsCircularReportAdmin = true;
          }
          if (this.userGroups.filter(ug => ug == ETenderAdminTypes.SCAServices_SmallUnits_smallunitsPS ||
            ug == ETenderAdminTypes.SCAServices_SmallUnits_smallunitsPT ||
            ug == ETenderAdminTypes.SCAServices_SmallUnits_smallunitsIS ||
            ug == ETenderAdminTypes.SCAServices_SmallUnits_FinancePS ||
            ug == ETenderAdminTypes.SCAServices_SmallUnits_FinancePT ||
            ug == ETenderAdminTypes.SCAServices_SmallUnits_ISMMarine
          ).length > 0 && !this.IsEbookingAdmin && !this.IsRegistrationAdmin && !this.IsLongHaulReportAdmin && !this.IsLongHaulAdmin && !this.IsETenderAdmin && !this.IsSupplierAdmin && !this.isShipyardAdmin) {
            this.IsSmallUnitsAdminOnly = true;
          }

        }
        this.global.IsLoaderEnabled = false;
      },
      () => console.log('Something went wrong!!')
    );
  }
  getUserNotificationsCounts() {
    if (window.location.hash.toLowerCase().indexOf("workspace") > -1) {
      this.workspaceService.getNotificationsCount(this.user.UserName, this.user.UserId == undefined ? "00000000-0000-0000-0000-000000000000" : this.user.UserId, this.IsAdmin).subscribe(
        data => this.myNotifications = data.Data,
        () => console.log('Something went wrong!!'),
        () => this.loadNotificationsCompleted()
      );
    }
  }
  loadNotificationsCompleted() { }
}
